var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { staticClass: "p-3 mt-2 shadow-sm bg-white" },
    [
      _c(
        "vs-col",
        { attrs: { "vs-lg": "4" } },
        [
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                { staticClass: "text-truncate", attrs: { "vs-lg": "12" } },
                [
                  _c(
                    "vs-chip",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.copyEmailToClipboard(_vm.item.id)
                        }
                      }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "send", color: "gray" }
                      }),
                      _vm._v(" " + _vm._s(_vm.item.id) + " ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                { attrs: { "vs-lg": "12" } },
                [
                  _c(
                    "vs-chip",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.copyEmailToClipboard(_vm.localTimestamp)
                        }
                      }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "event", color: "gray" }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("dateFormatDateTime")(_vm.localTimestamp)
                          ) +
                          " "
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("vs-col", { attrs: { "vs-lg": "7" } }, [
        _vm._v(" " + _vm._s(_vm.item.message) + " ")
      ]),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-lg": "1",
            "vs-type": "flex",
            "vs-justify": "center",
            "vs-align": "center"
          }
        },
        [
          _c("Options", {
            attrs: { item: _vm.item },
            on: { deleted: _vm.handleDeleted }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }